import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SignaturePad } from 'angular2-signaturepad';
import html2canvas from 'html2canvas';
import { cpf } from 'cpf-cnpj-validator';
import { BaseComponent } from '../base-component';

@Component({
  selector: 'app-signature-input',
  templateUrl: './signature-input.component.html',
  styleUrls: ['./signature-input.component.scss']
})
export class SignatureInputComponent extends BaseComponent implements OnInit {

  @Input() signatureName: string = '';
  @Output() signatureImg = new EventEmitter<string>();

  @ViewChild('screen') screen?: ElementRef;
  @ViewChild('canvas') canvas?: ElementRef;
  @ViewChild('downloadLink') downloadLink?: ElementRef;

  @ViewChild(SignaturePad) signaturePad?: SignaturePad;

  signaturePadOptions: Object = {
    'minWidth': 0.5,
    'maxWidth': 1.5,
    'canvasWidth': 430,
    'canvasHeight': 75,
    'penColor': "black"
  };

  fontArr: any[] = []

  writedSignatureInput: string = ''

  writeSignture = false

  startSign = false

  currentFont

  signatureBlob

  isMobile

  typingTimer;
  doneTypingInterval = 1500;
  isSignatureInputBlocked=false;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.fontArr = [
      {
        id: 0,
        fontName: ['wolframia f-40']
      },
      {
        id: 1,
        fontName: ['allison-script f-50']
      },
      {
        id: 2,
        fontName: ['arty-signature f-58']
      },
      {
        id: 3,
        fontName: ['beauty-dream f-50']
      },
      {
        id: 4,
        fontName: ['funky-signature f-50']
      },
      {
        id: 5,
        fontName: ['geovana f-50']
      },
      {
        id: 6,
        fontName: ['humaira-demo f-50']
      },
      {
        id: 7,
        fontName: ['monsieur-laDoulaise-regular f-50']
      },
      {
        id: 8,
        fontName: ['pwsignaturetwo f-50']
      }
    ]

    this.currentFont = this.fontArr[0]
    this.checkDevice()
  }

  checkDevice() {
    const width = window.screen.width;
    if(width < 1024) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  }

  ngAfterViewInit() {
    // this.signaturePad is now available
    this.signaturePad?.set('minWidth', 0.5);
    this.signaturePad?.set('maxWidth', 1.5);
    this.signaturePad?.clear(); // invoke functions from szimek/signature_pad API
  }

  drawComplete() {
    // will be notified of szimek/signature_pad's onEnd event
    this.signatureBlob = this.signaturePad?.toDataURL()
    this.signatureImg.emit(this.signaturePad?.toDataURL())
  }

  drawStart() {
    // will be notified of szimek/signature_pad's onBegin event
    console.log('begin drawing');
  }

  clearSignature() {
    this.writedSignatureInput = ''
    this.startSign = false
    this.signaturePad?.clear();
  }

  savePad() {
    this.signatureBlob = this.signaturePad?.toDataURL()
    this.signatureImg.emit(this.signatureBlob);
  }

  transformDivToImgFromScreen() {
    if(!this.isSignatureInputBlocked){
      this.isSignatureInputBlocked=true
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(() => { this.transformDivToImg();this.isSignatureInputBlocked=false; }, 
                                    this.doneTypingInterval);
   }
  }

  transformDivToImg() {

    html2canvas(this.screen!.nativeElement).then(canvas => {
      this.signatureBlob = canvas.toDataURL()
      this.signatureImg.emit(this.signatureBlob);
    });

  }
  
  getBase64Image(img) {
    var canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    var ctx = canvas.getContext("2d");
    ctx?.drawImage(img, 0, 0);
    var dataURL = canvas.toDataURL("image/png");
    return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
  }

  changeFont(id: number) {
    if (id == 8) {
      this.currentFont = this.fontArr[0]
    } else if (id < 8) {
      this.currentFont = this.fontArr[id + 1]
    }
    this.transformDivToImg()
  }
}
